import { useState } from 'react';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { useAuth } from './useAuth.ts';

/**
 * Cierra la sesión EN EL SERVIDOR y vuelve al login.
 *
 * Lo importante es que no se limita a olvidar el estado del cliente: llama a
 * `POST /auth/logout`, que revoca la fila de `sessions`. Un cierre de sesión que solo
 * borrara el estado local dejaría la cookie viva y la sesión utilizable.
 */
export function LogoutButton() {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [pending, setPending] = useState(false);

  async function handleClick() {
    setPending(true);
    try {
      await logout();
      void navigate('/login', { replace: true });
    } finally {
      setPending(false);
    }
  }

  return (
    <button type="button" className="btn-secundario text-sm"
      data-test="salir" onClick={handleClick} disabled={pending}>
      {pending ? t('auth.logout.pending') : t('auth.logout.action')}
    </button>
  );
}
